import Image from 'next/image';

import styled, { keyframes } from 'styled-components';

import { SPACING } from '~/common/constants/spacing';

export const SplashLoaderContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.neutral[950]};
  display: flex;
  flex-direction: column;
  gap: ${SPACING._32};
  justify-content: center;
  align-items: center;
`;

const blinkAnimation = keyframes`
  0%, 100% {
    filter: brightness(1.0);
  }
  50% {
    filter: brightness(1.5);
  }
`;

export const BlinkingImage = styled(Image)`
  transition: 100ms;
  animation: ${blinkAnimation} 1s infinite;
`;

export const BlinkingLogoImage = styled.img`
  width: 240px;
  max-width: calc(100vw - ${SPACING._48});
  max-height: 88px;
  object-fit: contain;
  transition: 100ms;
  animation: ${blinkAnimation} 1s infinite;
`;
